/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Recorder_Start_Label_ButtonInputs */



/**
* | output |
* | --- |
* | "Start recording" |
*
* @param {Audio_Recorder_Start_Label_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_recorder_start_label_button = /** @type {((inputs?: Audio_Recorder_Start_Label_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Recorder_Start_Label_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Démarrer l'enregistrement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Aufnahme starten")
	if (locale === "it") return /** @type {LocalizedString} */ ("Inizia la registrazione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Начать запись")
	if (locale === "es") return /** @type {LocalizedString} */ ("Iniciar grabación")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("开始录制")
	if (locale === "ja") return /** @type {LocalizedString} */ ("録音を開始")
	if (locale === "hi") return /** @type {LocalizedString} */ ("रिकॉर्डिंग शुरू करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Iniciar gravação")
	return /** @type {LocalizedString} */ ("Start recording")
});